import { Link } from "gatsby";
import React from "react";
import { parseCurrency } from "./discountPrice";
import { getCurrentPath } from "./getCurrentPath";

const CURRENCY = process.env.GATSBY_LOCALE_CURRENCY;
const COUNTRY_CODE = process.env.GATSBY_LOCALE_COUNTRY;
const CLUB_CLASS =
  process.env.GATSBY_CLUB_ACTIVE === "club_pt" ? "partner" : "club";
const CLUB_LABEL =
  process.env.GATSBY_CLUB_ACTIVE === "club_pt" ? "Partner" : "Club";
const isPartners = process.env.GATSBY_CLUB_ACTIVE === "club_pt";

const calculateDiscountPercentage = (rrp, salePrice) => {
  const discount = ((rrp - salePrice) / rrp) * 100;
  return Math.round(discount);
};

export const getPricingForCard = (pricing, clubPrice, isAuthenticated) => {
  const currencyFormatter = new Intl.NumberFormat("en-" + COUNTRY_CODE, {
    style: "currency",
    currency: CURRENCY,
  });

  if (pricing) {
    if (
      pricing.compareAtPrice != null &&
      pricing.compareAtPrice?.amount !== pricing.price?.amount
    ) {
      return (
        <div className="">
          <h4 className="text-secondary-700 tracking-wide flex items-center text-sm md:text-base">
            <span className="min-w-[80px]">
              Now {currencyFormatter.format(pricing.price.amount)}
            </span>
          </h4>
          <h4
            className={`tracking-wide text-[#E75301] leading-6 flex items-center text-sm md:text-base`}
          >
            <span className="min-w-[80px] text-gray-500">
              Was <span className="line-through">{currencyFormatter.format(pricing.compareAtPrice.amount)}</span>
            </span>
            {/* <span className="ml-1 text-[12px]">Non-{CLUB_LABEL} Price</span> */}
          </h4>
        </div>
      );
    } else if (clubPrice) {
      const comparePrice =
        pricing.compareAtPrice?.amount ?? pricing.price.amount;
      return (
          <div className="">
            {!isAuthenticated && (
              <>
                <h4
                    className={`text-gray-500 tracking-wide flex items-center flex-wrap text-sm md:text-base`}
                >
                  <span className="min-w-[60px]">
                    {currencyFormatter.format(comparePrice)}
                  </span>
                </h4>

                <h4
                    className={`text-${CLUB_CLASS} font-normal tracking-wide flex items-center flex-wrap text-sm md:text-base`}
                >
                  <span className="mr-1 inline-flex items-center leading-tight">{clubPrice}</span>
                  <strong
                      className={`text-white font-bold px-2 py-0 bg-${CLUB_CLASS} leading-5 text-[8px] rounded-full inline-block`}
                  >
                    {CLUB_LABEL} Price
                  </strong>
                </h4>
              </>
            )}
                {isAuthenticated && (
                    <>
                      <h4
                          className={`text-${CLUB_CLASS} font-bold tracking-wide flex items-center flex-wrap text-sm md:text-base`}
                      >
                        <span className="mr-1">Now</span>
                        <span className="mr-1 inline-flex items-center leading-tight">{clubPrice}</span>
                        <strong
                            className={`text-white font-bold px-1 md:px-2 py-0 bg-${CLUB_CLASS} leading-5 text-[8px] rounded-full inline-block`}
                        >
                          {CLUB_LABEL} Price
                        </strong>
                      </h4>
                      <h4
                          className={`text-gray-500 font-normal tracking-wide flex items-center flex-wrap text-base`}
                      >
                        <span className="mr-1">Was</span>
                        <span className="min-w-[60px] line-through">
                          {currencyFormatter.format(comparePrice)}
                        </span>
                      </h4>
                    </>
                )}
          </div>
      );
    } else {
      return (
          <div className="">
            <h4 className="block text-gray-500 tracking-wide min-w-[80px] w-full text-base">
              {currencyFormatter.format(pricing.price.amount)}{" "}
            </h4>
          </div>
      )
          ;
    }
  }
};

export const getPricingForCart = (
    pricing,
    isAuthenticated,
    quantity = 1,
    onOpen,
    bundleInfo = null // New parameter for bundle pricing
) => {
  const currencyFormatter = new Intl.NumberFormat("en-" + COUNTRY_CODE, {
    style: "currency",
    currency: CURRENCY,
  });
  const clubPrice =
      pricing.clubPrice?.value ?? pricing.product.clubPrice?.value;

  if (bundleInfo) {
    const bundlePrice = bundleInfo.bundlePrice * quantity;
    const originalPrice = bundleInfo.originalPrice * quantity;

    return (
        <div className="">
          <h4 className="md:w-[192px] text-left flex flex-wrap text-secondary-700 tracking-wide leading-7 items-center">
          <span>
            {currencyFormatter.format(bundlePrice)}
          </span>
            <strong className="ml-1 text-white font-bold px-2 py-0 bg-primary-600 leading-5 text-[8px] rounded-full inline-block">
              BUNDLE
            </strong>
          </h4>
          <h4 className="tracking-wide leading-7 flex items-center ml-auto md:w-[192px] text-left line-through text-[#808080]">
            {currencyFormatter.format(originalPrice)}
          </h4>
        </div>
    );
  }

  if (pricing) {
    if (
        pricing.compareAtPrice != null &&
        pricing.compareAtPrice?.amount !== pricing.price?.amount
    ) {
      return (
          <div className="">
            <h4 className="md:w-[192px] text-left flex flex-wrap text-secondary-700 tracking-wide leading-7 items-center">
            <span>
              {currencyFormatter.format(
                  parseFloat(pricing.price.amount) * quantity
              )}
            </span>
            </h4>
            <h4
                className={`tracking-wide leading-7 flex items-center ml-auto md:w-[192px] text-left line-through`}
            >
              {currencyFormatter.format(
                  parseFloat(pricing.compareAtPrice.amount) * quantity
              )}{" "}
            </h4>
          </div>
      );
    } else if (clubPrice) {
      const comparePrice =
          pricing.compareAtPrice?.amount ?? pricing.price.amount;
      return (
          <div className="text-left w-fit">
            <div
                className={`text-${CLUB_CLASS} tracking-wide flex flex-col-reverse xl:flex-row items-end xl:items-center`}
            >
              <h4 className="text-left flex flex-wrap items-center clear-both overflow-hidden whitespace-nowrap">
              <span>
                {currencyFormatter.format(parseCurrency(clubPrice) * quantity)}
              </span>
                <strong
                    className={`ml-1 text-white font-bold px-2 py-0 bg-${CLUB_CLASS} leading-5 text-[8px] rounded-full inline-block`}
                >
                  {CLUB_LABEL} <span className="hidden sm:inline">Price</span>
                </strong>
              </h4>
            </div>
            <h4
                className={`tracking-wide flex ml-auto items-center text-left text-[#808080] ${
                    isAuthenticated ? "line-through" : ""
                }`}
            >
              <span>{currencyFormatter.format(comparePrice * quantity)}</span>
            </h4>
          </div>
      );
    } else {
      return (
          <div className="">
            <h4 className="block tracking-wide leading-7">
              {currencyFormatter.format(
                  parseFloat(pricing.price.amount) * quantity
              )}{" "}
            </h4>
          </div>
      );
    }
  }
};

export const getPricingForBundle = (variants, bundlePrice, quantity) => {
  const currencyFormatter = new Intl.NumberFormat("en-" + COUNTRY_CODE, {
    style: "currency",
    currency: CURRENCY,
  });

  const totalRetailPrice = variants.reduce(function (acc, variant) {
    return acc + parseFloat(variant.compareAtPrice.amount);
  }, 0);

  return (
    <div className="">
      <h4 className="text-left flex flex-wrap text-secondary-700 tracking-wide leading-7 items-center">
          <span>
            {currencyFormatter.format(bundlePrice * quantity)}
          </span>
      </h4>
      <h4
          className={`tracking-wide flex ml-auto items-center text-left text-[#808080] line-through`}
      >
        {currencyFormatter.format(totalRetailPrice * quantity)}{" "}
      </h4>
    </div>
  );
};

export const getPricingForProduct = (
  pricing,
  clubPrice,
  isAuthenticated,
  clubTooltip,
  onClose
) => {
  const currencyFormatter = new Intl.NumberFormat("en-" + COUNTRY_CODE, {
    style: "currency",
    currency: CURRENCY,
  });

  if (pricing) {
    if (
      pricing.compareAtPrice != null &&
      pricing.compareAtPrice?.amount !== pricing.price?.amount
    ) {
      return (
        <div className="">
          <h4 className="text-secondary-700 tracking-wide leading-7 sm:leading-8 flex items-center">
            <span>Now {currencyFormatter.format(pricing.price.amount)}</span>
            <strong
                className="ml-[10px] min-w-[80px] text-center text-white font-bold px-3 py-0 bg-secondary-700 text-xs rounded-full h-8 leading-normal flex items-center justify-center">
              Save {calculateDiscountPercentage(parseFloat(pricing.compareAtPrice.amount), parseFloat(pricing.price.amount))}%
            </strong>
          </h4>
          <h4 className="block tracking-wide leading-7 sm:leading-8 line-through font-medium text-xl">
            Was {currencyFormatter.format(pricing.compareAtPrice.amount)}{" "}
          </h4>
        </div>
      );
    } else if (clubPrice) {
      const comparePrice =
          pricing.compareAtPrice?.amount ?? pricing.price.amount;
      return (
          <div className="">
            <h2
                className={`tracking-wide leading-8 sm:leading-8 flex items-center font-bold ${
                    isAuthenticated ? "line-through" : ""
                }`}
            >
              <span>{currencyFormatter.format(comparePrice)}</span>
              {/* <span className="ml-[10px] font-normal text-xs">
            Non-{CLUB_LABEL} Price
          </span> */}
            </h2>
            <div className="flex flex-col md:flex-row items-left md:items-center justify-between text-[22px] leading-normal">
              <h4
                  className={`text-${CLUB_CLASS} text-[22px] font-medium tracking-wide leading-8 sm:leading-8 flex items-flex-start md:items-center`}
              >
                <span>{clubPrice}</span>
                <strong
                    className={`ml-[14px] text-white text-[10px] font-bold px-[10px] py-[10px] bg-${CLUB_CLASS} text-xs rounded-full h-[24px] leading-none flex items-center clear-both overflow-hidden whitespace-nowrap`}>
                  {CLUB_LABEL} Price
                </strong>
              </h4>
              {!isAuthenticated && clubTooltip && (
                  <div
                      className="relative py-[6px] px-0 md:px-4 rounded-full flex ml-0 md:ml-4 text-[12px] leading-3 text-black/70 text-left md:text-right">
                    <p className="font-medium">
                      To access {CLUB_LABEL} Price{" "}
                      {!isPartners && (
                          <>
                            <Link
                                to="/pages/bushbuck-club"
                                className={`text-${CLUB_CLASS} font-semibold underline underline-offset-2`}
                            >
                              Join for free
                            </Link>{" "}
                          </>
                      )}
                      {isPartners && (
                          <>
                            <Link
                                className={`text-${CLUB_CLASS} font-semibold underline underline-offset-2`}
                                to="/account/register"
                            >
                              Sign up
                            </Link>{" "}
                          </>
                      )}
                      or{" "}
                      <Link
                          to="/account/login"
                          state={{redirectTo: getCurrentPath()}}
                          className={`text-${CLUB_CLASS} font-semibold`}
                      >
                        Login
                      </Link>
                    </p>
                  </div>
              )}
            </div>
          </div>
      );
    } else {
      return (
          <div className="">
            <h4 className="block tracking-wide leading-7 sm:leading-8">
              {currencyFormatter.format(pricing.price.amount)}{" "}
            </h4>
          </div>
      );
    }
  }
};

export const getInstallmentPricingForProduct = (
    pricing,
    clubPrice,
    isAuthenticated,
    noOfInstallments
) => {
  const currencyFormatter = new Intl.NumberFormat("en-" + COUNTRY_CODE, {
    style: "currency",
    currency: CURRENCY,
  });

  if (pricing && clubPrice) {
    if (!isAuthenticated) {
      const comparePrice =
        pricing.compareAtPrice?.amount ?? pricing.price.amount;

      return (
        <span>{currencyFormatter.format(comparePrice / noOfInstallments)}</span>
      );
    } else {
      return (
        <span>
          {currencyFormatter.format(
            parseCurrency(clubPrice) / noOfInstallments
          )}
        </span>
      );
    }
  } else if (
    pricing &&
    pricing.compareAtPrice != null &&
    pricing.compareAtPrice?.amount !== pricing.price?.amount
  ) {
    return (
      <span>
        {currencyFormatter.format(pricing.price.amount / noOfInstallments)}
      </span>
    );
  } else {
    return (
      <span>
        {currencyFormatter.format(pricing.price.amount / noOfInstallments)}{" "}
      </span>
    );
  }
};

export const getPricingForFavorites = (pricing, clubPrice, quantity = 1) => {
  const currencyFormatter = new Intl.NumberFormat("en-" + COUNTRY_CODE, {
    style: "currency",
    currency: CURRENCY,
  });

  if (pricing) {
    if (
      pricing &&
      pricing.contextualPricing.compareAtPrice != null &&
      pricing.contextualPricing.compareAtPrice?.amount !==
        pricing.contextualPricing.price?.amount
    ) {
      return (
        <div className="">
          <h4 className="w-40 sm:w-48 text-left flex text-secondary-700 tracking-wide leading-7 items-center">
            <span>
              {currencyFormatter.format(
                pricing.contextualPricing.price.amount * quantity
              )}
            </span>
          </h4>
          <h4
            className={`tracking-wide leading-7 flex items-center ml-auto w-40 sm:w-48  text-left line-through`}
          >
            {currencyFormatter.format(
              pricing.contextualPricing.compareAtPrice.amount * quantity
            )}{" "}
          </h4>
        </div>
      );
    } else if (clubPrice) {
      const comparePrice =
        pricing.contextualPricing.compareAtPrice?.amount ??
        pricing.contextualPricing.price.amount;
      return (
        <div className="text-right h-full">
          <div
            className={`text-${CLUB_CLASS} tracking-wide leading-7 flex flex-col-reverse xl:flex-row items-end xl:items-center`}
          >
            <h4 className="w-60 text-left flex items-center justify-end clear-both overflow-hidden whitespace-nowrap">
              <span>
                {currencyFormatter.format(parseCurrency(clubPrice) * quantity)}
              </span>
              <strong
                className={`ml-[10px] min-w-[80px] text-white font-bold px-3 py-0 bg-${CLUB_CLASS} text-[12px] rounded-full inline-block clear-both overflow-hidden whitespace-nowrap`}
              >
                {CLUB_LABEL} Price
              </strong>
            </h4>
          </div>
          <h4
            className={`tracking-wide leading-7 flex items-center ml-auto w-60 justify-end  text-left line-through`}
          >
            <span>{currencyFormatter.format(comparePrice * quantity)}</span>
            {/* <span className="ml-[10px] font-normal text-[12px] inline-block clear-both overflow-hidden whitespace-nowrap">
            Non-{CLUB_LABEL} Price
          </span> */}
          </h4>
        </div>
      );
    } else {
      return (
        <div className="">
          <h4 className="block tracking-wide leading-7">
            {currencyFormatter.format(
              pricing.contextualPricing.price.amount * quantity
            )}{" "}
          </h4>
        </div>
      );
    }
  }
};
